import { formatGoalResultText } from '../../../utils/casinoUtils';

export default function GoalResult({ detail }) {
  return (
    <div className="d-flex justify-content-center">
      <div className="cricket20ballpopup cricket20ballresult goalresult">
        <img src="https://wver.sprintstaticdata.com/v230/static/admin/img/balls/soccer-ball.png" />
        {' '}
        <span>{formatGoalResultText(detail?.rdesc)}</span>
      </div>
    </div>
  );
}
